import { DecisionTypeCode } from "decisions";
import { PracticeReview, PRBaseStatusCode, PRPhaseCode } from "practice-reviews";
import { CurrentUser, Permissions } from "users";

export function showLinkAndActionsGenerateButton(
  practiceReview: PracticeReview | undefined,
  currentUser: CurrentUser,
  reviewerMustBeLead: boolean
) {
  if (!practiceReview) return null;

  // if the review is still in the scheduling phase, then perform review documents can't be generated at all
  if (practiceReview.phase.id < PRPhaseCode.PerformPracticeReview) {
    return false;
  }

  // if the review has been returned, then ReturnedPR.Update is required to generate perform review documents
  if (practiceReview.hasBeenReturned) {
    return currentUser.userHasPermission(Permissions.ReturnedPrUpdate);
  }

  // otherwise, you have to be assigned to the review,
  return (
    currentUser.userIsLeadReviewer(practiceReview) ||
    (!reviewerMustBeLead && // but if you don't have to be lead, then you could be an other reviewer
      currentUser.userIsOtherReviewer(practiceReview))
  );
}

export function getReasonPrTypeCannotBeChanged(practiceReview: PracticeReview | undefined) {
  if (!practiceReview) return null;

  if (practiceReview.decisions.find((dec) => dec.decisionType.typeCode === DecisionTypeCode.Manager)?.signedOff)
    return "Manager decision has already been signed off.";

  if (practiceReview.reviewType === "PPRP Program") return "Cannot change type of PPRP Program Reviews.";

  return null;
}

export function getReasonPrStatusCannotBeChanged(practiceReview: PracticeReview | undefined, currentUser: CurrentUser) {
  if (!practiceReview || !currentUser) return null;

  if (!currentUser.userHasPermission(Permissions.PrChangeStatus)) {
    return "You do not have permission to change the status of this review.";
  }

  if (practiceReview.status.baseStatusCode === PRBaseStatusCode.Removed) {
    return "Cannot change type of a removed review.";
  }

  if (practiceReview.pprpProgramReviewRegComItems?.length) {
    return "This review is now linked to a Registration Committee Item and its status cannot be changed.";
  }

  return null;
}
